import { formatCurrency } from '../utils/format';
import './Referrals.css';

interface ReferralsProps {
  referrals: any[];
}

export function Referrals({ referrals }: ReferralsProps) {
  const activeReferrals = referrals.filter(r => r.status === 'active');
  const inactiveReferrals = referrals.filter(r => r.status === 'inactive');

  return (
    <div className="referrals">
      <div className="referrals-header">
        <div className="referrals-stat">
          <p className="referrals-stat-label">Всего</p>
          <p className="referrals-stat-value">{referrals.length}</p>
        </div>
        <div className="referrals-stat">
          <p className="referrals-stat-label">Активных</p>
          <p className="referrals-stat-value active">{activeReferrals.length}</p>
        </div>
        <div className="referrals-stat">
          <p className="referrals-stat-label">Неактивных</p>
          <p className="referrals-stat-value inactive">{inactiveReferrals.length}</p>
        </div>
      </div>

      {activeReferrals.length > 0 && (
        <div className="referrals-section">
          <h3 className="section-title">Активные рефералы</h3>
          <div className="referrals-list">
            {activeReferrals.map((referral) => (
              <ReferralCard key={referral.id} referral={referral} />
            ))}
          </div>
        </div>
      )}

      {inactiveReferrals.length > 0 && (
        <div className="referrals-section">
          <h3 className="section-title">Неактивные рефералы</h3>
          <div className="referrals-list">
            {inactiveReferrals.map((referral) => (
              <ReferralCard key={referral.id} referral={referral} inactive />
            ))}
          </div>
        </div>
      )}

      {referrals.length === 0 && (
        <div className="empty-state">
          <div className="empty-icon">👥</div>
          <h3>Пока нет рефералов</h3>
          <p>Поделитесь своей реферальной ссылкой, чтобы начать зарабатывать</p>
        </div>
      )}
    </div>
  );
}

function ReferralCard({ referral, inactive = false }: { referral: any; inactive?: boolean }) {
  const timeSinceActive = getTimeSince(referral.lastActiveAt);
  const timeSinceRegistered = getTimeSince(referral.registeredAt);

  return (
    <div className={`referral-card ${inactive ? 'inactive' : ''}`}>
      <div className="referral-card-header">
        <div className="referral-avatar">
          {referral.username?.charAt(0).toUpperCase() || '?'}
        </div>
        <div className="referral-info">
          <p className="referral-name">{referral.username || 'Anonymous'}</p>
          <p className="referral-time">
            Регистрация: {timeSinceRegistered}
          </p>
        </div>
        <div className={`referral-status ${referral.status}`}>
          {referral.status === 'active' ? '🟢' : '⚪'}
        </div>
      </div>
      <div className="referral-card-body">
        <div className="referral-metric">
          <p className="referral-metric-label">Доход</p>
          <p className="referral-metric-value">{formatCurrency(referral.totalRevenue)}</p>
        </div>
        <div className="referral-metric">
          <p className="referral-metric-label">Последняя активность</p>
          <p className="referral-metric-value">{timeSinceActive}</p>
        </div>
      </div>
    </div>
  );
}

function getTimeSince(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Только что';
  if (diffMins < 60) return `${diffMins} мин. назад`;
  if (diffHours < 24) return `${diffHours} ч. назад`;
  if (diffDays < 7) return `${diffDays} дн. назад`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} нед. назад`;
  return `${Math.floor(diffDays / 30)} мес. назад`;
}
